const camelCase = (str) =>
  str
    .toLowerCase()
    .replace(/[_-]/g, " ")
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (ltr, idx) =>
      idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase()
    )
    .replace(/\s+/g, "");

export default camelCase;
